import { StyleObject } from 'styletron-react';
import {
	borderColor,
	borderRadius,
	borderStyle,
	borderWidth,
	marginSize,
	paddingSize,
} from '../../Utilities/utils/Theming';
import { IDummyProps } from './types';

export const cardRootStyle = (props: IDummyProps) => {
	return {
		...paddingSize('0px', '0px', '0px', '0px'),
		height: props.expanded ? '100%' : 'auto',
		...borderRadius('var(--epods--border-radius)'),
		...borderWidth('1px'),
		...borderStyle('solid'),
		...borderColor('var(--epods--color-border-light)'),
		boxShadow: '0px 2px 4px rgba(94, 124, 143, 0.15)',
		backgroundColor: 'var(--epods--color-bg)',
		overflow: 'hidden',
	} as StyleObject;
};

export const CardGeneralStyles = {
	cardTitleContiner: () => {
		return {
			paddingBottom: 'var(--epods--space-inset-m)',
			borderBottom: 'solid 1px var(--epods--color-border-light)',
			display: 'flex',
			alignItems: 'flex-end',
		} as StyleObject;
	},
	cardTitleStyle: (props: IDummyProps, theme: any) => {
		const withEllipsis = props.headerEllipsis
			? {
					textOverflow: 'ellipsis',
					width: '100%',
					overflow: 'hidden',
					wordBreak: 'break-all',
					whiteSpace: 'pre',
			  }
			: {};

		return {
			...withEllipsis,
			fontFamily: theme.card.headerFontFont,
			fontSize: theme.card.headerFontSize,
			lineHeight: theme.card.headerFontHeight,
			color: 'var(--epods--color-text-primary)',
			display: 'display',
			paddingRight: 'var(--epods--space-inset-s)',
		} as StyleObject;
	},
	cardContentStyle: () => {
		const paddingValue = '0px';

		return {
			...paddingSize(paddingValue, paddingValue, paddingValue, paddingValue),
			...marginSize(paddingValue, paddingValue, paddingValue, paddingValue),
			display: 'flex',
			flexDirection: 'column',
			height: '100%',
			alignItems: 'stretch',
			overflow: 'hidden',
		} as StyleObject;
	},

	cardBodyStyle: (size?: 'default' | 'compact', hideHeader?: boolean) => {
		let paddingValue = 'var(--epods--space-inset-m)';
		if (size === 'compact') {
			paddingValue = 'var(--epods--space-inset-s)';
			if (hideHeader) {
				paddingValue = 'var(--epods--space-inset-s2)';
			}
		}
		return {
			...paddingSize(paddingValue, paddingValue, paddingValue, paddingValue),
			...marginSize('0', '0', '0', '0'),
			overflowY: 'hidden',
			flex: '1 1',
			position: 'relative',
			color: 'var(--epods--color-text-primary)',
		} as StyleObject;
	},
};
